/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyRegistrationInvoiceDto } from './CompanyRegistrationInvoiceDto';
import type { InvoiceDto } from './InvoiceDto';
import type { ProductApprovalCheckStepDto } from './ProductApprovalCheckStepDto';
import type { ProductApprovalInvoiceDto } from './ProductApprovalInvoiceDto';
export type ProductApprovalInvoiceCheckStepDto = (ProductApprovalCheckStepDto & {
    state?: ProductApprovalInvoiceCheckStepDto.state;
    readonly invoice?: (InvoiceDto | CompanyRegistrationInvoiceDto | ProductApprovalInvoiceDto);
});
export namespace ProductApprovalInvoiceCheckStepDto {
    export enum state {
        NOT_AVAILABLE = 'NOT_AVAILABLE',
        OPEN = 'OPEN',
        SENT = 'SENT',
        OVERDUE = 'OVERDUE',
        PAID = 'PAID',
        UNPAID = 'UNPAID',
    }
}

